import React from "react";
import PropTypes from "prop-types";

import Tippy from "@tippyjs/react";

import "./style.scss";

const Tooltip = ({ content, ...rest }) => {
  return (
    <Tippy
      placement={"top"}
      arrow={true}
      theme={"custom"}
      animation={"scale-extreme"}
      trigger={"click"}
      offset={[0, 15]}
      content={content}
    >
      {rest.children}
    </Tippy>
  );
};

Tooltip.propTypes = {
  content: PropTypes.any.isRequired,
};

export default Tooltip;
